export default {
  computed: {
    isViewer() {
      return this.$store.getters['user/isViewer'];
    },
  },
};
